import { createContext, useContext } from 'react';

export interface ApiAuthContextValue {
  isAuthReady: boolean;
}

export const ApiAuthContext = createContext<ApiAuthContextValue>({ isAuthReady: false });

/**
 * Hook to access API auth readiness state
 * Use this to gate queries until the token getter is initialized
 */
export function useApiAuth() {
  return useContext(ApiAuthContext);
}
